import React from 'react'
import { History, ChevronDown, ChevronUp, Plus, Loader2 } from 'lucide-react'

/**
 * Component to display version history and handle version management
 * do not remove, modify as needed
 */
const VersionHistory = ({
  versions,
  showVersions,
  onToggleVersions,
  onVersionSelect,
  onSaveVersion,
  isProcessing,
  isPainting,
  featureFlagSaveVersion
}) => {
  // Helper to render version status
  const renderVersionStatus = (version) => {
    if (version.status === 'processing') {
      return (
        <div className="flex items-center text-blue-400">
          <Loader2 className="w-3 h-3 mr-1 animate-spin" />
          <span className="text-xs">Processing</span>
        </div>
      )
    }
    if (version.status === 'failed') {
      return <span className="text-xs text-red-400">Failed</span>
    }
    return <span className="text-xs text-gray-400">
      {new Date(version.createdAt).toLocaleTimeString()}
    </span>
  }

  return (
    <div className="border-t border-gray-700 mt-auto">
      {showVersions && versions.length > 0 && (
        <div className="p-4 border-b border-gray-700 max-h-48 overflow-y-auto">
          {versions.slice().reverse().map((version) => (
            <button
              key={version.id}
              onClick={() => onVersionSelect(version)}
              disabled={version.status === 'processing'}
              className={`w-full text-left p-2 hover:bg-gray-700 rounded mb-2 last:mb-0
                ${version.status === 'processing' ? 'opacity-70 cursor-wait' : ''}
                ${version.status === 'failed' ? 'opacity-50' : ''}`}
            >
              <div className="flex justify-between items-center">
                <div className="flex flex-col">
                  <span>Version {version.versionNumber}</span>
                  {version.toolMetadata?.toolType && (
                    <span className="text-xs text-gray-400">
                      {version.toolMetadata.toolType}
                    </span>
                  )}
                </div>
                {renderVersionStatus(version)}
              </div>
            </button>
          ))}
        </div>
      )}
      
      <div className="p-4 space-y-4">
        {versions.length > 0 && (
          <button
            onClick={() => onToggleVersions(!showVersions)}
            className="w-full p-4 bg-gray-700 rounded-lg hover:bg-gray-600 transition-colors text-left"
          >
            <div className="flex items-center gap-3">
              <div className="p-2 bg-gray-600 rounded-md">
                <History className="w-5 h-5" />
              </div>
              <div>
                <div className="font-medium">Version History</div>
                <div className="text-sm text-gray-400">
                  {versions.length} version{versions.length !== 1 ? 's' : ''} available
                </div>
              </div>
              <div className="ml-auto">
                {showVersions ? <ChevronDown size={16} /> : <ChevronUp size={16} />}
              </div>
            </div>
          </button>
        )}
        { featureFlagSaveVersion && (
          <button
            onClick={onSaveVersion}
            disabled={isProcessing || isPainting}
            className={`w-full p-4 bg-gray-700 rounded-lg hover:bg-gray-600 transition-colors text-left
              ${(isProcessing || isPainting) ? 'opacity-50 cursor-not-allowed' : ''}`}
          >
            <div className="flex items-center gap-3">
              <div className="p-2 bg-gray-600 rounded-md">
                {isProcessing ? (
                  <Loader2 className="w-5 h-5 animate-spin" />
                ) : (
                  <Plus className="w-5 h-5" />
                )}
              </div>
              <div>
                <div className="font-medium">Save New Version</div>
                <div className="text-sm text-gray-400">
                  {isProcessing ? 'Saving...' : 
                   isPainting ? 'Finish painting to save' : 
                   'Create a new version of this image'}
                </div>
              </div>
            </div>
          </button>
        )}
      </div>
    </div>
  )
}

export default VersionHistory 